import { ProductPackagingType } from '@shared/api/types';
import Text from '@shared/components/content/text';
import Unit from '@shared/components/content/unit';
import { EmissionBarCell } from '@shared/components/data-table/cells/emission-bar-cell';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { NumberCell } from '@shared/components/data-table/cells/number-cell';
import { ColumnDef } from '@tanstack/react-table';

export function useProductPackagingTableColumns(
  maxEmissions: number
): ColumnDef<ProductPackagingType>[] {
  return [
    {
      id: 'item',
      accessorKey: 'name',
      size: 170,
      minSize: 170,
      maxSize: 170,
      header: ({ column }) => <HeaderCell column={column} name="Item" />,
      cell: ({ getValue }) => {
        const name = getValue<string>();
        return (
          <Text includeHover className="block  w-full max-w-60 truncate">
            {name}
          </Text>
        );
      },
    },
    {
      id: 'spacer',
      header: () => null,
      cell: () => null,
      size: 70,
      minSize: 70,
      maxSize: 70,
      enableSorting: false,
    },
    {
      id: 'emissions',
      accessorKey: 'totalEmissionsPerItem',
      size: 80,
      minSize: 80,
      header: ({ column }) => (
        <HeaderCell
          column={column}
          name="Emissions"
          numberColumn
          unit={<Unit variant="kgCO2e" />}
        />
      ),
      cell: ({ getValue }) => {
        const emissions = getValue<number>();
        return <NumberCell number={emissions} />;
      },
    },
    {
      id: 'bar',
      accessorKey: 'totalEmissionsPerItem',
      header: () => <div className="w-full" />,
      enableSorting: false,
      size: 130,
      maxSize: 130,
      minSize: 130,
      cell: ({ row }) => {
        const emissions = row.original.totalEmissionsPerItem;
        const carbonIntensity = row.original.totalEmissionsPerKg;
        return (
          <EmissionBarCell
            type="packaging"
            emissions={emissions}
            maxEmissions={maxEmissions}
            carbonIntensity={carbonIntensity}
            className="w-full pr-2"
          />
        );
      },
    },
  ];
}
